/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';
import Syphon from 'backbone.syphon';
import Ladda from 'ladda';
import Radio from 'backbone.radio';

import { validateForm } from '@/util/ParsleyUtils';
import showErrorMessage from '@/util/showErrorMessage';

import tmplAWPackageRemarkModalView from './AWPackageRemarkModalView.hbs';

const AWPackageRemarkModalView = View.extend({
  template: tmplAWPackageRemarkModalView,

  ui: {
    btnCancel: '.btn-no',
    btnAdd: '.btn-yes',
    remarkForm: '.remark-form'
  },

  events: {
    'click @ui.btnCancel': 'onClickCancel',
    'click @ui.btnAdd': 'onClickAdd'
  },

  onRender() {
    if (this.options.editRemark) {
      const oldRemark = {};
      oldRemark.description = this.model.get('description');
      oldRemark.remark = this.model.get('remark');
      Syphon.deserialize(this.ui.remarkForm, oldRemark);
    }
  },

  onClickCancel(e) {
    e.preventDefault();
    this.triggerMethod('modal:close', false);
  },

  async onClickAdd(e) {
    e.preventDefault();
    const spinner = Ladda.create(this.ui.btnAdd.get(0));
    spinner.start();

    try {
      await validateForm(this.ui.remarkForm);
    } catch (err) {
      spinner.stop();
      return;
    }

    const remark = Syphon.serialize(this.ui.remarkForm);
    remark.isSelected = '0';
    try {
      if (this.options.editRemark) {
        Radio.channel('remarks').trigger('edit:remark', remark);
      } else {
        Radio.channel('remarks').trigger('add:remark', remark);
      }
      this.triggerMethod('modal:close', true);
    } catch (err) {
      this.showAddError();
      this.triggerMethod('modal:close', true);
    } finally {
      spinner.stop();
    }
  },

  showAddError() {
    showErrorMessage({
      errorCode: 'addError',
      errorTitle: 'Add Remark Error',
      errorMessage: 'An error occurred during add remark. Try again or contact an administrator if your issue persists.'
    });
  }
});

export default AWPackageRemarkModalView;
